import React, { useContext, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import Truck from 'assets/customizeIcons/Truck.svg';
import ProductIcon from 'assets/customizeIcons/product.svg';
import SimulatorIcon from 'assets/customizeIcons/simulator.svg';
import Input from 'components/bootstrap/forms/Input';
import DevisTable from './DevisTable';
import UpdateDevisLineModal from './UpdateDevisLineModal';
import AuthContext from 'contexts/authContext';
import { useLogicDevis } from 'pages/Devis/hooks/useLogicDevis';
import Button from 'components/bootstrap/Button';
import SimulatorPopUp from 'pages/Devis/components/Simulateur/SimulatorPopUp';
import Forfait from 'assets/img/forfaits.png';
import MainDoeuvre from 'assets/img/main-doeuvre.png';
import Garantie from 'assets/img/garantie.png';

import { useLogicProduit } from 'pages/Stock/hooks/useLogicProduit';
import SimulatorPopUpFacile from 'pages/Devis/components/SimulateurFacile/SimulatorPopUpFacile';
import voletRoulantData from 'constants/simulatorDataFacile/voletRoulant';
import forfaitsVolet from 'constants/simulatorDataFacile/voletRoulant/forfaits';
import forfaitsStore from 'constants/simulatorDataFacile/Storebanne/forfaits';
import forfaitsRideau from 'constants/simulatorDataFacile/rideauMetallique/forfaits';
import forfaitsPorte from 'constants/simulatorDataFacile/PorteGarage/forfaits';
import forfaitsPortail from 'constants/simulatorDataFacile/Portail/forfaits';
import PorteGarageData from 'constants/simulatorDataFacile/PorteGarage';
import PortailData from 'constants/simulatorDataFacile/Portail';
import simulatorData from 'constants/simulatorDataDetails';
import MainOuvreDataVolet from 'constants/simulatorDataFacile/voletRoulant/mainOeuvre';
import MainOuvreDataRideau from 'constants/simulatorDataFacile/rideauMetallique/mainOeuvre';
import MainOuvreDataPorte from 'constants/simulatorDataFacile/PorteGarage/mainOeuvre';
import MainOuvreDataPortail from 'constants/simulatorDataFacile/Portail/mainOeuvre';
import MainOuvreDataStore from 'constants/simulatorDataFacile/Storebanne/mainOeuvre';
import voletRoulant from 'constants/simulatorDataDetails/voletRoulant';
import StoreBanneData from 'constants/simulatorDataDetails/Storebanne';
import RideauMetalliqueData from 'constants/simulatorDataDetails/rideauMetallique';
import ForfaitsSM from 'constants/simulatorDataFacile/Forfaits';
import MainOuvreData from 'constants/simulatorDataFacile/MainOuvre';
import SvgArrowBack from "assets/customizeIcons/svg-icons/ArrowBackIcon";
import { COLORS } from './Mobile';
import SaveIcon from 'assets/customizeIcons/svg-icons/SaveIcon.js';

function CreateDevisModal({ isOpen, onClose, interventionData, AddDevis }) {
	const [lineDevisPopup, setLineDevisPopup] = useState(false);
	const [selectedLineDevis, setSelectedLineDevis] = useState(false);
	const [editModalSimulator, setEditModalSimulator] = useState(false);
	const [editModalSimulatorFacile, setEditModalSimulatorFacile] = useState(false);
	const [editModalForfait, setEditModalForfait] = useState(false);
	const [addSimulatorLoading, setAddSimulatorLoading] = useState(false);

	const [currentFormValue, setCurrentFormValue] = useState({});
	const [spinner, setSpinner] = useState(false);
	const [error, setError] = useState();
	const [totalPriceRemise, settotalPriceRemise] = useState();
	const [remiseMontant, setRemiseMontant] = useState();
	const [remise, setRemise] = useState(0);
	const [success, setSuccess] = useState(false);
	const [project_title, setProject_title] = useState();
	const [spinnerGarantie, setSpinnerGarantie] = useState(false);
	const [spinnerDepacement, setSpinnerDepacement] = useState(false);
	const [createProductPopup, setCreateProductPopup] = useState(false);
	const [scrollEnabled, setScrollEnabled] = useState(true);
	const [warningMsg, setWarningMsg] = useState();
	const [selectedTax, setSelectedTax] = useState();
	const [devisModel, setDevisModel] = useState(false);
	const [selectedDevis, setSelectedDevis] = useState({});
	const [modalVisible, setModalVisible] = useState(false);
	const { userData } = useContext(AuthContext);
	const { createProduit } = useLogicProduit();
	const simulatorMap = {
		porte: PorteGarageData,
		portail: PortailData,
	};

	const simulatorDetailsMap = {
		volet: voletRoulant,
		store: StoreBanneData,
		rideaux: RideauMetalliqueData,
	};
	const forfaitMap = {
		volet: forfaitsVolet,
		store: forfaitsStore,
		rideaux: forfaitsRideau,
		porte: forfaitsPorte,
		portail: forfaitsPortail,
	};
	const mainDoeuvreMap = {
		volet: MainOuvreDataVolet,
		store: MainOuvreDataStore,
		rideaux: MainOuvreDataRideau,
		porte: MainOuvreDataPorte,
		portail: MainOuvreDataPortail,
	};
	const modalTitle = {
		volet: 'VOLET ROULANT',
		store: 'STORE BANNE',
		rideaux: 'RIDEAU METALLIQUE',
		porte: 'PORTE DE GARAGE',
		portail: 'PORTAIL ELECTRIQUE',
	};
	const [data, setData] = useState({
		name: 'devis ' + interventionData?.client?.nom + ' ' + interventionData?.reference,
		lignes: [],
		notesClient: '',
		tva: 10,
		totalTTC: 0,
		montantTVA: 0,
		totalHT: 0,
	});
	const addDeplacement = () => {
		const alreadyExists = (data?.lignes || []).some(
			(ligne) => ligne?.description === 'Déplacement',
		);

		// Do not add if it already exists
		if (alreadyExists) return;
		const newLigne = {
			type: 'service',
			produitId: null,
			nom: 'Déplacement', // CORRECTION: Initialiser le champ nom
			description: 'Déplacement',
			quantite: 1,
			unite: 'Piece',
			prixUnitaireHT: 50,
		};
		const newAmountUntaxed = data?.totalHT + 50;
		const newAmountTVA = newAmountUntaxed * (data?.tva / 100);
		console.log('newAmountUntaxed', newAmountTVA, data?.tva / 100);

		setData((prev) => ({
			...prev,
			updated: true,
			totalTTC: newAmountUntaxed + newAmountTVA,
			montantTVA: newAmountTVA,
			totalHT: newAmountUntaxed,
			lignes: [...(prev?.lignes || []), newLigne],
		}));
	};

	const addGarantie = () => {
		const alreadyExists = (data?.lignes || []).some(
			(ligne) => ligne?.description === 'Garantie 5 ans',
		);

		// Do not add if it already exists
		if (alreadyExists) return;
		const newLigne = {
			type: 'note',
			produitId: null,
			nom: 'Garantie', // CORRECTION: Initialiser le champ nom
			description: 'Garantie 5 ans',
			quantite: 1,
			prixUnitaireHT: 0,
		};

		setData((prev) => ({
			...prev,
			updated: true,
			lignes: [...(prev?.lignes || []), newLigne],
		}));
	};
	const { createDevis } = useLogicDevis();

	const handleCreateDevis = async () => {
		setSpinner(true);
		const technicienIds =
			interventionData?.cars
				?.flatMap((car) => (car?.conducteurs || []).map((c) => c?.technicien))
				?.map((t) => t?._id || t?.id)
				?.filter(Boolean) || [];
		const payload = {
			clientId: interventionData?.client?._id,
			companyId: interventionData?.cars[0]?.companyId,
			createdBy: userData?.id,
			dateValidite: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
				.toISOString()
				.split('T')[0],
			name: data?.name,
			lignes: data?.lignes,
			tva: data?.tva,
			technicienIds,
		};
		const resultDevis = await createDevis(payload);
		AddDevis(resultDevis?.data);
		setSpinner(false);
		onClose();
	};

	const handelAddSimulatorLine = async () => {
		setAddSimulatorLoading(true);
		let description = '';
		let nom = currentFormValue?.category?.label;
		let newLine = '';

		const productFinal = currentFormValue?.productFinal;
		console.log('currentFormValue', currentFormValue);
		// if (currentFormValue?.category?.id == 'MO' || currentFormValue?.category?.id == 'FOR') {
		// 	//description = productFinal?.description || productFinal[0]?.description;
		// 	if (productFinal?.length) {
		// 		// description += productFinal[0].description;
		// 		productFinal.forEach((item) => {
		// 			description += '\n - ' + (item.description || item.label || item.value);
		// 		});
		// 	} else {
		// 		description += productFinal?.description;
		// 	}
		// 	console.log('description', description);
		// } else {
		// 	description = 'Fourniture de ';

		// 	if (productFinal?.length) {
		// 		// description += productFinal[0].description;
		// 		productFinal.forEach((item) => {
		// 			description += '\n - ' + item.label;
		// 		});
		// 	} else {
		// 		description += productFinal?.description;
		// 	}
		// 	nom = 'Fourniture de ' + currentFormValue?.category?.label;
		// }

		if (currentFormValue?.productFinal?.production) {
			newLine = {
				type: 'produit',
				nom: nom,
				description: description,
				// produitId: currentFormValue?.productFinal?.length
				// 	? currentFormValue?.productFinal[0]?.product_id
				// 	: currentFormValue?.productFinal?.product_id,
				// prixUnitaireHT:
				// 	currentFormValue?.productFinal?.lst_price !== undefined &&
				// 	currentFormValue?.productFinal?.lst_price !== null
				// 		? currentFormValue?.productFinal?.lst_price == 0
				// 			? currentFormValue?.productFinal?.lst_price
				// 			: 1
				// 		: 1,
				prixUnitaireHT:
					currentFormValue?.productFinal?.lst_price !== undefined &&
						currentFormValue?.productFinal?.lst_price !== null
						? currentFormValue?.productFinal?.lst_price !== 0
							? currentFormValue?.productFinal?.lst_price
							: 1
						: 1,
				quantite: 1,
				unite: 'Piece',
				categorie: 'materiel',
			};
			const dbLine = {
				name: newLine?.nom,
				description: newLine?.description,
				type: 'stockable',
				unit: 'Piece',
				sellingPrice: newLine?.prixUnitaireHT,
			};
			const res = await createProduit(dbLine);
			setAddSimulatorLoading(false);
			setCurrentFormValue({});
			setEditModalSimulator(false);
			const newAmountUntaxed = data?.totalHT + newLine?.prixUnitaireHT;
			const newAmountTVA = newAmountUntaxed * (data?.tva / 100);
			console.log('newAmountUntaxed', newAmountTVA, data?.tva / 100);

			setData((prev) => ({
				...prev,
				updated: true,
				totalTTC: newAmountUntaxed + newAmountTVA,
				montantTVA: newAmountTVA,
				totalHT: newAmountUntaxed,
				lignes: [...(prev?.lignes || []), { ...newLine, produitId: res?.data?._id }],
			}));
		} else {
			console.log('new line');
			newLine = {
				type: 'service',
				nom: nom,
				description: description,
				prixUnitaireHT: 0,
				quantite: 1,
				unite: 'Piece',
				categorie: 'materiel',
			};

			setAddSimulatorLoading(false);
			setCurrentFormValue({});
			setEditModalSimulator(false);
			const newAmountUntaxed = data?.totalHT + newLine?.prixUnitaireHT;
			const newAmountTVA = newAmountUntaxed * (data?.tva / 100);
			console.log('newAmountUntaxed', newAmountTVA, data?.tva / 100);

			setData((prev) => ({
				...prev,
				updated: true,
				totalTTC: newAmountUntaxed + newAmountTVA,
				montantTVA: newAmountTVA,
				totalHT: newAmountUntaxed,
				lignes: [...(prev?.lignes || []), newLine],
			}));
		}
	};

	const handelAddFournitureLine = async () => {
		setAddSimulatorLoading(true);
		let description = '';
		let nom = currentFormValue?.category?.label;
		let newLine = '';

		const descriptionFinal = currentFormValue?.productFinal;

		newLine = {
			type: 'produit',
			nom: 'Fourniture',
			description: descriptionFinal,

			prixUnitaireHT: 1,
			quantite: 1,
			unite: 'Piece',
			categorie: 'materiel',
		};
		const dbLine = {
			name: newLine?.nom,
			description: newLine?.description,
			type: 'stockable',
			unit: 'Piece',
			sellingPrice: newLine?.prixUnitaireHT,
		};
		const res = await createProduit(dbLine);
		setAddSimulatorLoading(false);
		setCurrentFormValue({});
		setEditModalSimulator(false);
		const newAmountUntaxed = data?.totalHT + newLine?.prixUnitaireHT;
		const newAmountTVA = newAmountUntaxed * (data?.tva / 100);
		console.log('newAmountUntaxed', newAmountTVA, data?.tva / 100);

		setData((prev) => ({
			...prev,
			updated: true,
			totalTTC: newAmountUntaxed + newAmountTVA,
			montantTVA: newAmountTVA,
			totalHT: newAmountUntaxed,
			lignes: [...(prev?.lignes || []), { ...newLine, produitId: res?.data?._id }],
		}));
	};
	const calcTotals = (lignes = [], tauxTVA = 0) => {
		const totalHT = lignes.reduce(
			(sum, l) => sum + (Number(l?.quantite) || 0) * (Number(l?.prixUnitaireHT) || 0),
			0,
		);

		const tva = totalHT * ((Number(tauxTVA) || 0) / 100);
		return { totalHT, montantTVA: tva, totalTTC: totalHT + tva };
	};

	const handelCreateForfaitLine = async () => {
		setAddSimulatorLoading(true);

		try {
			const motif = interventionData?.motif; // ✅ define motif
			const baseTitle = modalTitle?.[motif] ?? 'Intervention';
			const description = currentFormValue?.productFinal;
			// const description = formatDescription(currentFormValue);
			const prixUnitaireHT = currentFormValue['price'];
			const lineToAdd = {
				type: 'service',
				produitId: null,
				nom: `Forfait ${baseTitle}`,
				description,
				quantite: 1,
				unite: 'Piece',
				prixUnitaireHT,
			};

			// ✅ Update devis draft state (lines + totals) once
			setData((prev) => {
				const newLignes = [...(prev?.lignes || []), lineToAdd];
				const tauxTVA = Number(prev?.tauxTVA) || 0;
				const totals = calcTotals(newLignes, tauxTVA);

				return {
					...prev,
					updated: true,
					lignes: newLignes,
					...totals,
				};
			});

			// ✅ reset UI
			setCurrentFormValue({});
			setEditModalForfait(false);
		} catch (err) {
			console.error('❌ Error:', err);
			showNotification('Erreur', err?.message || 'Erreur inconnue', 'danger');
		} finally {
			setAddSimulatorLoading(false);
		}
	};
	const handelCreateMainDoeuvreLine = async () => {
		setAddSimulatorLoading(true);

		try {
			const motif = interventionData?.motif; // ✅ define motif
			const baseTitle = modalTitle?.[motif] ?? 'Intervention';
			const description = `Main d'oeuvre:\n${currentFormValue?.productFinal}`;
			// const description = formatDescription(currentFormValue);
			const prixUnitaireHT = currentFormValue['price'];
			const lineToAdd = {
				type: 'service',
				produitId: null,
				nom: `MainDoeuvre ${baseTitle}`,
				description,
				quantite: 1,
				unite: 'Piece',
				prixUnitaireHT,
			};

			// ✅ Update devis draft state (lines + totals) once
			setData((prev) => {
				const newLignes = [...(prev?.lignes || []), lineToAdd];
				const tauxTVA = Number(prev?.tauxTVA) || 0;
				const totals = calcTotals(newLignes, tauxTVA);

				return {
					...prev,
					updated: true,
					lignes: newLignes,
					...totals,
				};
			});

			// ✅ reset UI
			setCurrentFormValue({});
			setEditModalForfait(false);
		} catch (err) {
			console.error('❌ Error:', err);
			showNotification('Erreur', err?.message || 'Erreur inconnue', 'danger');
		} finally {
			setAddSimulatorLoading(false);
		}
	};
	const handelCreateFournitureLine = async () => {
		try {
			const motif = interventionData?.motif; // ✅ define motif
			const baseTitle = modalTitle?.[motif] ?? 'Intervention';
			const description = currentFormValue?.productFinal;
			// const description = formatDescription(currentFormValue);
			const dbLine = {
				name: baseTitle,
				description,
				type: 'stockable',
				unit: 'Piece',
				sellingPrice: 0,
			};

			const resProduit = await createProduit(dbLine);
			const produitId = resProduit?.data?._id;
			const lineToAdd = {
				type: 'produit',
				produitId: produitId,
				nom: `Fourniture ${baseTitle}`,
				description,
				quantite: 1,
				unite: 'Piece',
				prixUnitaireHT: 0,
			};

			// ✅ Update devis draft state (lines + totals) once
			setData((prev) => {
				const newLignes = [...(prev?.lignes || []), lineToAdd];
				const tauxTVA = Number(prev?.tauxTVA) || 0;
				const totals = calcTotals(newLignes, tauxTVA);

				return {
					...prev,
					updated: true,
					lignes: newLignes,
					...totals,
				};
			});

			// ✅ reset UI
			setCurrentFormValue({});
			setEditModalSimulatorFacile(false);
		} catch (err) {
			console.error('❌ Error:', err);
			showNotification('Erreur', err?.message || 'Erreur inconnue', 'danger');
		} finally {
			setAddSimulatorLoading(false);
		}
		setAddSimulatorLoading(true);
	};
	return (
		<Modal show={true} onHide={() => { }} fullscreen scrollable>

			<Modal.Header className="bg-white border-bottom">
				<div
					style={{
						width: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						gap: 10,
					}}
				>
					{/* Bouton Retour */}
					<div
						onClick={onClose}
						style={{
							color: COLORS.INFO
						}}
					>
						<SvgArrowBack size={25} color={COLORS.INFO} />
						Retour
					</div>
					<Button
						onClick={handleCreateDevis}
						disabled={spinner}
						style={{
							height: 35,
							borderRadius: 8,
							display: 'flex',
							alignItems: 'center',
							gap: 8,
							padding: '0 16px',
							backgroundColor: COLORS.PRIMARY,
							border: 'none',
						}}
					>
						<SaveIcon size={18} color={COLORS.WHITE} />
						<span style={{ color: COLORS.WHITE }}>{spinner ? 'Loading...' : 'Enregistrer'}</span>
					</Button>

				</div>
			</Modal.Header>

			<Modal.Body className='p-0'>
				<div>
					<h1 style={{ color: COLORS.DEFAULT }} className='mt-5 text-center'>
						Nouveau devis
					</h1>

					<div className='p-3'>
						{/* ===== INPUT ===== */}
						<div>
							<div
								style={{ color: COLORS.DEFAULT }}
								className='mb-2 ms-4 fw-semibold'>
								Titre de devis
							</div>
							<Input
								type='text'
								value={data?.name || ''}
								onChange={(e) => setData({ ...data, name: e.target.value })}
								className='rounded-5'
								style={{ height: '50px ' }}
							/>
						</div>

						{/* ===== ACTION BUTTONS ===== */}
						<div className='actions mt-4'>
							<button
								className='action-btn'
								onClick={() => {

									setEditModalSimulator(true);
								}}>
								<img src={SimulatorIcon} alt='Simulateur' />
								<span>Fourniture</span>
							</button>
							<button
								className='action-btn'
								onClick={() => setEditModalForfait('forfaits')}>
								<img src={Forfait} alt='Produit' />
								<span>Forfaits</span>
							</button>
							<button
								className='action-btn'
								onClick={() => setEditModalForfait('main')}>
								<img src={MainDoeuvre} alt='Produit' />
								<span>Main d'oeuvre</span>
							</button>
						</div>
						<div className='gap-4 d-flex mt-4'>
							<button
								className='action-btn justify-content-center w-50'
								onClick={addDeplacement}
								disabled={spinnerDepacement}>
								<img src={Truck} alt='Déplacement' />
								<span>Déplacement</span>
							</button>
							<button
								className='action-btn justify-content-center w-50'
								onClick={addGarantie}
								disabled={spinnerDepacement}>
								<img src={Garantie} alt='Déplacement' />
								<span>Garantie</span>
							</button>
						</div>

						{/* ===== TABLE ===== */}
						<DevisTable
							cardId={data?.id}
							card={data?.lignes}
							totalPriceRemise={totalPriceRemise}
							settotalPriceRemise={settotalPriceRemise}
							remise={remise}
							setRemise={setRemise}
							remiseMontant={remiseMontant}
							setRemiseMontant={setRemiseMontant}
							isDisabled={data?.state == 'done'}
							updateLineDevis={(line) => {
								setSelectedLineDevis(line);
								setLineDevisPopup(true);
							}}
							setScrollEnabled={setScrollEnabled}
							data={data}
							setData={setData}
							selectedTax={selectedTax}
							setSelectedTax={setSelectedTax}
						/>
					</div>

					{/* ===== NOTES ===== */}
					<div className='form-group'>
						<div className='textarea-wrapper'>
							<label className='textarea-label'>Notes de devis</label>

							<textarea
								className='textarea-input'
								value={data?.notesClient || ''}
								onChange={(e) => setData({ ...data, notesClient: e.target.value })}
								rows={4}
							/>
						</div>
					</div>

					{/* ===== FOOTER ===== */}
					{/* <div className='footer-actions row m-4'>
						<Button
							isLight
							className='col-12'
							color='primary'
							onClick={handleCreateDevis}
							disabled={spinner}>
							{spinner ? 'Loading...' : 'Enregistrer'}
						</Button>
					</div> */}
				</div>

				{lineDevisPopup && (
					<UpdateDevisLineModal
						index={selectedLineDevis?.index}
						ligne={selectedLineDevis}
						setVisible={() => setLineDevisPopup(false)}
						setData={setData}
					/>
				)}
				{!!editModalSimulator && (
					<SimulatorPopUp
						setEditModalSimulator={setEditModalSimulator}
						data={{
							order_id: 1,
							modalTitle: 'Conception de produits et simulation',
							cardTitle: 'Simulate Product',
						}}
						simulatorData={simulatorData}
						currentFormValue={currentFormValue}
						setCurrentFormValue={setCurrentFormValue}
						handelCreateLine={handelAddFournitureLine}>
						<Row className='px-3'>
							<Col>
								{/* {currentFormValue?.complet && ( */}
								<Button
									variant='outline-info'
									onClick={() => {
										console.log('finaaaaal', currentFormValue?.productFinal);
										handelAddFournitureLine();
									}}
									disabled={!currentFormValue?.complet || addSimulatorLoading}
									style={{
										borderRadius: '10px',
										width: '100%',
										backgroundColor: 'rgba(23, 162, 184, 0.1)',
										border: '1px solid #17a2b8',
									}}>
									{!!currentFormValue?.complet ? addSimulatorLoading ? (
										<>
											<span className='spinner-border spinner-border-sm me-2' />
											Loading...
										</>
									) : (
										<span style={{ color: '#17a2b8', fontWeight: '600' }}>
											Ajouter au devis
										</span>
									) : "⚠️ Simulation incomplète"}

								</Button>
								{/* )} */}
							</Col>
						</Row>
					</SimulatorPopUp>
				)}
				{!!editModalForfait && (
					<SimulatorPopUpFacile
						setEditModalSimulator={setEditModalForfait}
						data={{
							order_id: 1,
							modalTitle: `${modalTitle[interventionData?.motif]}`,
							cardTitle: 'Simulate Product',
						}}
						simulatorData={editModalForfait == 'forfaits' ? ForfaitsSM : MainOuvreData}
						currentFormValue={currentFormValue}
						setCurrentFormValue={setCurrentFormValue}>
						<Row className='px-2 px-md-3'>
							<Button
								color='primary'
								onClick={() => {
									editModalForfait == 'forfaits'
										? handelCreateForfaitLine()
										: handelCreateMainDoeuvreLine();
								}}
								disabled={
									!(
										currentFormValue &&
										typeof currentFormValue === 'object' &&
										Object.values(currentFormValue).some(
											(v) =>
												v !== null &&
												v !== undefined &&
												String(v).trim() !== '',
										)
									) || addSimulatorLoading
								}
								style={{
									borderRadius: '10px',
									width: '100%',
								}}>
								{addSimulatorLoading ? (
									<>
										<span className='spinner-border spinner-border-sm me-2' />
										Loading...
									</>
								) : (
									'Sauvegarder'
								)}
							</Button>
						</Row>
					</SimulatorPopUpFacile>
				)}

			</Modal.Body>
		</Modal>
	);
}

export default CreateDevisModal;
